import React from 'react';
import SupplierList  from '../components/Supplier_List';
import { Row, Col, Breadcrumb } from 'antd';
import { Link } from 'react-router-dom';

const Supplier = () => {
  
  return (
    <div style={{ padding: '0px 0px 0px 20px' }}>
      <h3>Clientes</h3>
      <Breadcrumb style={{ marginBottom: 16 }}>
          <Breadcrumb.Item>
            <Link to="/">Início</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>Clientes</Breadcrumb.Item>
        </Breadcrumb>
      <Row>
        <Col
          xs={0} // Esconde em dispositivos pequenos
          sm={0} // Esconde em dispositivos médios
          md={24} // Mostra em dispositivos maiores ou iguais a 'md'
        >
          <SupplierList />
        </Col>
        <Col
          xs={24} // Esconde em dispositivos pequenos
          sm={24} // Esconde em dispositivos médios
          md={0} // Mostra em dispositivos maiores ou iguais a 'md'
        >
          <SupplierList />
        </Col>
      </Row>
    </div>
  );
};

export default Supplier;